import { render } from "./NewItemActivityBadge.vue?vue&type=template&id=0af045fb&scoped=true"
import script from "./NewItemActivityBadge.vue?vue&type=script&lang=js"
export * from "./NewItemActivityBadge.vue?vue&type=script&lang=js"

import "./NewItemActivityBadge.vue?vue&type=style&index=0&id=0af045fb&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0af045fb"

export default script